export default __webpack_public_path__ + "static/media/chili-paper.b9caf512.svg";